import { render, staticRenderFns } from "./modalConversaoHE.vue?vue&type=template&id=389744fb&scoped=true&"
import script from "./modalConversaoHE.vue?vue&type=script&lang=js&"
export * from "./modalConversaoHE.vue?vue&type=script&lang=js&"
import style0 from "./modalConversaoHE.vue?vue&type=style&index=0&id=389744fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389744fb",
  null
  
)

export default component.exports